import { FormDefinitionService } from '@app/core/services/form-definition.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { CustomFormlyFieldConfig } from '@app/core/interfaces/formly-forms.interface';

@Component({
  selector: 'formly-field-accordion-wrapper',
  templateUrl: './formly-field-accordion-wrapper.component.html',
  styleUrls: ['./formly-field-accordion-wrapper.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IonicModule,
    FormlyModule,
    TranslateModule,
  ],
})
export class FormlyFieldAccordionWrapperComponent extends FieldWrapper {
  private formDefinitionService =inject(FormDefinitionService);


  public hasVisibleChildren(): boolean {
    const flattenedFields = this.formDefinitionService.flattenFormFields(this.field.fieldGroup as CustomFormlyFieldConfig[] || []);
    return flattenedFields.some(f => !f.hide && f.type !== 'HIDDEN');
  }
}